import React from "react";
import "./dropdown.css";

//

function DropdownMenu({ config, _callback, depthLevel, submenu, error }) {
  const selector = (item) => {
    _callback(item);
  };
  const getMenuItemTitle = (menuItem, index, depthLevel) => {
    return { title: menuItem.nameRu, id: menuItem.id };
  };
  const getMenuItem = (menuItem, depthLevel, index) => {
    let title = getMenuItemTitle(menuItem, index, depthLevel);
    if (menuItem.children.length > 0) {
      return (
        <li key={index}>
          <p onClick={() => selector(menuItem)}>{title.title}</p>
          <DropdownMenu
            _callback={_callback}
            config={menuItem.children}
            depthLevel={depthLevel + 1}
            submenu={true}
          />
        </li>
      );
    } else {
      return (
        <li key={index}>
          <p onClick={() => selector(menuItem)}> {title.title}</p>
        </li>
      );
    }
  };
  let options = [];
  config.forEach((item, index) => {
    options.push(getMenuItem(item, 0, index));
  });

  if (submenu && submenu === true) {
    return <ul>{options}</ul>;
  }
  return (
    <ul className={`my-dropdown-menu ${error ? "error" : ""}`}>{options} </ul>
  );
}
export default DropdownMenu;
